// extracted by mini-css-extract-plugin
module.exports = {"TopArea":"TopArea_TopArea__VRbCv","Uploading":"TopArea_Uploading__vcO10"};